/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
import React, { useState } from "react";
import {
  useHistory,
} from "react-router-dom";
import Login from "../components/Login";
import { login } from "../../../api/UserServices";
import UserData from "../../../common/security/UserData";
import { isAuthenticated, hasAccessRights } from "../../../common/security/PermissionUtils";

const LoginContainer = () => {
  const history = useHistory();
  const [loginData, setLoginData] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [showPasssword, setShowPassword] = useState(false);

  if (isAuthenticated()) {
    history.push({ pathname: "/customers" });
  }

  const handleSubmitLoginDetails = (e) => {
    e.preventDefault();
    const requestData = {
      username: loginData.username && loginData.username.trim(),
      password: loginData.password,
    };
    setSubmitting(true);
    login(requestData).then((response) => {
      setSubmitting(false);
      if (response && response.success && response.data) {
        const {
          data: {
            token, name, accessibleCompanies, accessRights,
          },
        } = response;
        UserData.setAll({
          token,
          name,
          authenticated: true,
          accessibleCompanies,
          accessRights,
        });
        if (hasAccessRights(["ViewCustomersLink"])) {
          history.push({ pathname: "/customers" });
        } else if (hasAccessRights(["ViewSeasonsLink"])) {
          history.push({ pathname: "/seasons" });
        } else if (hasAccessRights(["ViewProductBrandsLink"])) {
          history.push({ pathname: "/product-brands" });
        } else {
          history.push({ pathname: "/404" });
        }
      } else {
        setError("Incorrect username or password");
      }
    });
  };

  /**
 * This method is used to handle change IN text
 *
 * @param {String} key
 * @param {Object} e
 */
  const handleChange = (key, e) => {
    setError("");
    setLoginData({ ...loginData, [key]: e.target.value });
  };

  const toggleShowPassword = () => setShowPassword(!showPasssword);

  return (
    <>
      <Login
        handleSubmitLoginDetails={handleSubmitLoginDetails}
        loginData={loginData}
        error={error}
        submitting={submitting}
        handleChange={handleChange}
        toggleShowPassword={toggleShowPassword}
        showPasssword={showPasssword}
      />
    </>
  );
};
export default LoginContainer;
